module.exports = __webpack_public_path__ + "static/media/sample-auction.4aa0787b.xlsx";